import { readItems } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { directusClient } from '../services/directusClient/directusClient.ts';

export const useCategoriesItemsQuery = () =>
  useQuery({
    queryKey: ['categories'],
    queryFn: () => directusClient.request(readItems('categories')),
  });
